import React from "react";
import { BookOpenIcon, ClipboardCheckIcon, FileTextIcon, ListIcon, MapIcon, MessageSquareIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { collectionItems } from "../../data/landingContent";
const iconMap = {
  map: MapIcon,
  check: ClipboardCheckIcon,
  file: FileTextIcon,
  book: BookOpenIcon,
  message: MessageSquareIcon,
  index: ListIcon
};
export function CollectionSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-127" data-mp="1v4asc6ts5eim">
      <SectionHeading eyebrow="Your complete digital reference collection" title="When you purchase, you'll receive all six volumes in digital format." data-id="element-128" data-mp="1v4ub1pr986xp" />
      <ul className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-129" data-mp="1ld7tzcs8jdn1">
        {collectionItems.map(c => {
        const Icon = iconMap[c.icon];
        return <li key={c.title} className="flex gap-4 border-t border-plum/10 pt-5" data-id="element-130" data-mp="2e1byvw2zfmoo">
              <Icon className="h-7 w-7 shrink-0 text-rose" aria-hidden="true" data-id="element-131" data-mp="2g5d25x5jrjg5" />
              <div data-id="element-132" data-mp="2k6f10cvjxthl">
                <h3 className="font-serif text-lg font-bold text-ink" data-id="element-133" data-mp="2k4u9yx8g4soh">{c.title}</h3>
                <p className="mt-1 text-[16px] leading-relaxed text-muted" data-id="element-134" data-mp="26faac0a5wbje">{c.body}</p>
              </div>
            </li>;
      })}
      </ul>
      <p className="mx-auto mt-8 max-w-2xl text-center font-serif text-lg italic text-plum" data-id="element-135" data-mp="2bbh4kvt73yli">
        Every resource is designed to complement your clinical judgment, not replace it.
      </p>
      <CtaButton className="mt-8" label="Get all six volumes now" subtext="Instant Digital Access · One-Time Payment · $27" data-id="element-136" data-mp="21db50kuv34jt" />
    </section>;
}